import React from 'react';

import TextareaAutosize from './textarea_autosize.jsx';

export default ({ url, onUrlChange, ...props })=>
  <TextareaAutosize 
    {...props} 
    value={url}
    onChange={(e)=> { onUrlChange(e.target.value.replace('\n', '')); }}
  />;